import { tr } from "./localization";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, Check } from "lucide-react";
import { useApp, Button, Modal } from "./shared";
import { useTaskSummary } from "./task-pages";

export function FirstRun() {
  const { me, boards, create } = useApp();
  const mine = useTaskSummary("?mode=mine");
  const authored = useTaskSummary("?mode=delegated");
  const board =
    boards.find(
      (b) => b.department_id === me.department_id && !b.is_archived,
    ) || boards.find((b) => !b.is_archived);
  const visited = !!localStorage.getItem("ims-board-visited:" + me.id);
  const created = !!authored.data?.total;
  const steps = [
    { title: "Задайте пароль", done: true },
    {
      title: "Подключите Telegram",
      text: "Задачи и напоминания будут приходить в мессенджер — отвечать можно прямо там",
      done: !!me.telegram_connected,
      action: (
        <Link className="btn primary small" to="/profile">
          {tr("Подключить")}
        </Link>
      ),
    },
    {
      title: "Создайте первую задачу",
      text: "Хотя бы себе — чтобы увидеть, как всё работает. Нажмите C",
      done: created,
      action: (
        <Button className="primary small" onClick={() => create()}>
          {tr("Создать")}
        </Button>
      ),
    },
    {
      title: "Загляните на доску своего отдела",
      text: "Там видно, кто чем занят и что в работе",
      done: visited,
      action: board ? (
        <Link className="btn small" to={"/boards/" + board.id}>
          {tr("Открыть доску")}
        </Link>
      ) : (
        <Link className="btn small" to="/boards">
          {tr("Доски")}
        </Link>
      ),
    },
  ];
  const done = steps.filter((s) => s.done).length;
  return (
    <div className="page first-run-page">
      <div>
        <h1>
          {tr("Добро пожаловать в IMS Tasks")}, {me.name.split(" ")[0]}!
        </h1>
        <p className="muted">
          {tr("Три шага — и вы готовы работать. Это займёт пару минут.")}
        </p>
      </div>
      <div>
        <div className="row first-run-progress-label">
          <b>
            {tr("Готово")} {done} {tr("из 4")}
          </b>
          <span className="muted">
            {done === 4
              ? tr("Всё готово")
              : tr("Осталось шагов: ") + (4 - done)}
          </span>
        </div>
        <div className="first-run-progress">
          <i style={{ width: (done / 4) * 100 + "%" }} />
        </div>
      </div>
      <div className="first-run-steps">
        {steps.map((step, i) => (
          <section
            className={"surface first-run-step" + (step.done ? " done" : "")}
            key={step.title}
          >
            <span className="step-number">
              {step.done ? <Check size={18} /> : i + 1}
            </span>
            <div>
              <b>{tr(step.title)}</b>
              {step.text && <p className="muted">{tr(step.text)}</p>}
            </div>
            {!step.done && step.action}
          </section>
        ))}
      </div>
      {mine.data?.total ? (
        <Link className="btn primary" to="/">
          {tr("К моим задачам")}
        </Link>
      ) : (
        <div className="surface first-run-empty">
          <span className="no-access-art">
            <Inbox size={28} />
          </span>
          <h2>{tr("Задач пока нет")}</h2>
          <p className="muted">
            {tr(
              "Когда коллеги поручат вам задачу, она появится здесь, а в Telegram придёт уведомление",
            )}
          </p>
        </div>
      )}
    </div>
  );
}

export function OnboardingTour() {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const finish = () => {
    localStorage.setItem("ims-tour-v1", "done");
    setOpen(false);
  };
  useEffect(() => {
    const show = () => {
      setStep(0);
      setOpen(true);
    };
    window.addEventListener("ims-show-tour", show);
    return () => window.removeEventListener("ims-show-tour", show);
  }, []);
  const steps = [
    {
      title: tr("Создавайте задачи за несколько секунд"),
      text: tr(
        "Нажмите C или «Новая задача». Укажите доску, исполнителя и срок. В быстром вводе работают @имя, завтра и !срочно.",
      ),
    },
    {
      title: tr("Сдавайте результат и принимайте работу"),
      text: tr(
        "Исполнитель нажимает «Сдать на проверку», автор — «Принять» или «Вернуть» с причиной. Задача себе закрывается кнопкой «Выполнено». Отмена доступна 10 секунд.",
      ),
    },
    {
      title: tr("Все сроки — в одном месте"),
      text: tr(
        "В «Моих задачах» собраны поручения со всех досок. В «Я поставил» — ваши поручения коллегам. Telegram можно подключить в профиле; веб работает и без него.",
      ),
    },
  ];
  return (
    <Modal
      open={open}
      title={tr("Добро пожаловать в IMS Tasks")}
      onClose={finish}
    >
      <p className="muted">
        {step + 1} / {steps.length}
      </p>
      <h2>{steps[step].title}</h2>
      <p>{steps[step].text}</p>
      <footer>
        <Button onClick={finish}>{tr("Разберусь сам")}</Button>
        <Button
          className="primary"
          onClick={() =>
            step === steps.length - 1 ? finish() : setStep(step + 1)
          }
        >
          {step === steps.length - 1 ? tr("Начать работу") : tr("Дальше")}
        </Button>
      </footer>
    </Modal>
  );
}
